var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 241,
    viewBox: "0 0 352 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_36509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 0.909185C2.06935 1.29967 1.75279 1.61622 1.36231 1.61622C0.971825 1.61622 0.655273 1.29967 0.655273 0.909185C0.655273 0.5187 0.971825 0.202148 1.36231 0.202148C1.75279 0.202148 2.06935 0.5187 2.06935 0.909185Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 0.909124C20.4522 1.29961 20.1355 1.61616 19.7451 1.61616C19.3547 1.61616 19.0381 1.29961 19.0381 0.909124C19.0381 0.518639 19.3547 0.202087 19.7451 0.202087C20.1355 0.202087 20.4522 0.518639 20.4522 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 0.909124C38.835 1.29961 38.5184 1.61616 38.1279 1.61616C37.7375 1.61616 37.4209 1.29961 37.4209 0.909124C37.4209 0.518639 37.7375 0.202087 38.1279 0.202087C38.5184 0.202087 38.835 0.518639 38.835 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 0.909124C57.2178 1.29961 56.9012 1.61616 56.5107 1.61616C56.1203 1.61616 55.8037 1.29961 55.8037 0.909124C55.8037 0.518639 56.1203 0.202087 56.5107 0.202087C56.9012 0.202087 57.2178 0.518639 57.2178 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 0.909124C75.6016 1.29961 75.285 1.61616 74.8945 1.61616C74.5041 1.61616 74.1875 1.29961 74.1875 0.909124C74.1875 0.518639 74.5041 0.202087 74.8945 0.202087C75.285 0.202087 75.6016 0.518639 75.6016 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 0.909124C93.9844 1.29961 93.6678 1.61616 93.2773 1.61616C92.8869 1.61616 92.5703 1.29961 92.5703 0.909124C92.5703 0.518639 92.8869 0.202087 93.2773 0.202087C93.6678 0.202087 93.9844 0.518639 93.9844 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 0.909124C112.367 1.29961 112.051 1.61616 111.66 1.61616C111.27 1.61616 110.953 1.29961 110.953 0.909124C110.953 0.518639 111.27 0.202087 111.66 0.202087C112.051 0.202087 112.367 0.518639 112.367 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 0.909124C130.75 1.29961 130.433 1.61616 130.043 1.61616C129.653 1.61616 129.336 1.29961 129.336 0.909124C129.336 0.518639 129.653 0.202087 130.043 0.202087C130.433 0.202087 130.75 0.518639 130.75 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 0.909124C149.133 1.29961 148.816 1.61616 148.426 1.61616C148.036 1.61616 147.719 1.29961 147.719 0.909124C147.719 0.518639 148.036 0.202087 148.426 0.202087C148.816 0.202087 149.133 0.518639 149.133 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 0.909124C167.516 1.29961 167.199 1.61616 166.809 1.61616C166.418 1.61616 166.102 1.29961 166.102 0.909124C166.102 0.518639 166.418 0.202087 166.809 0.202087C167.199 0.202087 167.516 0.518639 167.516 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 19.2921C2.06935 19.6825 1.75279 19.9992 1.36231 19.9992C0.971825 19.9992 0.655273 19.6825 0.655273 19.2921C0.655273 18.9017 0.971825 18.5851 1.36231 18.5851C1.75279 18.5851 2.06935 18.9017 2.06935 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 19.2921C20.4522 19.6825 20.1355 19.9992 19.7451 19.9992C19.3547 19.9992 19.0381 19.6825 19.0381 19.2921C19.0381 18.9017 19.3547 18.5851 19.7451 18.5851C20.1355 18.5851 20.4522 18.9017 20.4522 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 19.2921C38.835 19.6825 38.5184 19.9992 38.1279 19.9992C37.7375 19.9992 37.4209 19.6825 37.4209 19.2921C37.4209 18.9017 37.7375 18.5851 38.1279 18.5851C38.5184 18.5851 38.835 18.9017 38.835 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 19.2921C57.2178 19.6825 56.9012 19.9992 56.5107 19.9992C56.1203 19.9992 55.8037 19.6825 55.8037 19.2921C55.8037 18.9017 56.1203 18.5851 56.5107 18.5851C56.9012 18.5851 57.2178 18.9017 57.2178 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 19.2921C75.6016 19.6825 75.285 19.9992 74.8945 19.9992C74.5041 19.9992 74.1875 19.6825 74.1875 19.2921C74.1875 18.9017 74.5041 18.5851 74.8945 18.5851C75.285 18.5851 75.6016 18.9017 75.6016 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 19.2921C93.9844 19.6825 93.6678 19.9992 93.2773 19.9992C92.8869 19.9992 92.5703 19.6825 92.5703 19.2921C92.5703 18.9017 92.8869 18.5851 93.2773 18.5851C93.6678 18.5851 93.9844 18.9017 93.9844 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 19.2921C112.367 19.6825 112.051 19.9992 111.66 19.9992C111.27 19.9992 110.953 19.6825 110.953 19.2921C110.953 18.9017 111.27 18.5851 111.66 18.5851C112.051 18.5851 112.367 18.9017 112.367 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 19.2921C130.75 19.6825 130.433 19.9992 130.043 19.9992C129.653 19.9992 129.336 19.6825 129.336 19.2921C129.336 18.9017 129.653 18.5851 130.043 18.5851C130.433 18.5851 130.75 18.9017 130.75 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 19.2921C149.133 19.6825 148.816 19.9992 148.426 19.9992C148.036 19.9992 147.719 19.6825 147.719 19.2921C147.719 18.9017 148.036 18.5851 148.426 18.5851C148.816 18.5851 149.133 18.9017 149.133 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 19.2921C167.516 19.6825 167.199 19.9992 166.809 19.9992C166.418 19.9992 166.102 19.6825 166.102 19.2921C166.102 18.9017 166.418 18.5851 166.809 18.5851C167.199 18.5851 167.516 18.9017 167.516 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 37.6752C2.06935 38.0657 1.75279 38.3823 1.36231 38.3823C0.971825 38.3823 0.655273 38.0657 0.655273 37.6752C0.655273 37.2848 0.971825 36.9682 1.36231 36.9682C1.75279 36.9682 2.06935 37.2848 2.06935 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 37.6752C20.4522 38.0657 20.1355 38.3823 19.7451 38.3823C19.3547 38.3823 19.0381 38.0657 19.0381 37.6752C19.0381 37.2848 19.3547 36.9682 19.7451 36.9682C20.1355 36.9682 20.4522 37.2848 20.4522 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 37.6752C38.835 38.0657 38.5184 38.3823 38.1279 38.3823C37.7375 38.3823 37.4209 38.0657 37.4209 37.6752C37.4209 37.2848 37.7375 36.9682 38.1279 36.9682C38.5184 36.9682 38.835 37.2848 38.835 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 37.6752C57.2178 38.0657 56.9012 38.3823 56.5107 38.3823C56.1203 38.3823 55.8037 38.0657 55.8037 37.6752C55.8037 37.2848 56.1203 36.9682 56.5107 36.9682C56.9012 36.9682 57.2178 37.2848 57.2178 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 37.6752C75.6016 38.0657 75.285 38.3823 74.8945 38.3823C74.5041 38.3823 74.1875 38.0657 74.1875 37.6752C74.1875 37.2848 74.5041 36.9682 74.8945 36.9682C75.285 36.9682 75.6016 37.2848 75.6016 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 37.6752C93.9844 38.0657 93.6678 38.3823 93.2773 38.3823C92.8869 38.3823 92.5703 38.0657 92.5703 37.6752C92.5703 37.2848 92.8869 36.9682 93.2773 36.9682C93.6678 36.9682 93.9844 37.2848 93.9844 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 37.6752C112.367 38.0657 112.051 38.3823 111.66 38.3823C111.27 38.3823 110.953 38.0657 110.953 37.6752C110.953 37.2848 111.27 36.9682 111.66 36.9682C112.051 36.9682 112.367 37.2848 112.367 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 37.6752C130.75 38.0657 130.433 38.3823 130.043 38.3823C129.653 38.3823 129.336 38.0657 129.336 37.6752C129.336 37.2848 129.653 36.9682 130.043 36.9682C130.433 36.9682 130.75 37.2848 130.75 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 37.6752C149.133 38.0657 148.816 38.3823 148.426 38.3823C148.036 38.3823 147.719 38.0657 147.719 37.6752C147.719 37.2848 148.036 36.9682 148.426 36.9682C148.816 36.9682 149.133 37.2848 149.133 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 37.6752C167.516 38.0657 167.199 38.3823 166.809 38.3823C166.418 38.3823 166.102 38.0657 166.102 37.6752C166.102 37.2848 166.418 36.9682 166.809 36.9682C167.199 36.9682 167.516 37.2848 167.516 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 56.0577C2.06935 56.4482 1.75279 56.7648 1.36231 56.7648C0.971825 56.7648 0.655273 56.4482 0.655273 56.0577C0.655273 55.6673 0.971825 55.3507 1.36231 55.3507C1.75279 55.3507 2.06935 55.6673 2.06935 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 56.0577C20.4522 56.4482 20.1355 56.7648 19.7451 56.7648C19.3547 56.7648 19.0381 56.4482 19.0381 56.0577C19.0381 55.6673 19.3547 55.3507 19.7451 55.3507C20.1355 55.3507 20.4522 55.6673 20.4522 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 56.0577C38.835 56.4482 38.5184 56.7648 38.1279 56.7648C37.7375 56.7648 37.4209 56.4482 37.4209 56.0577C37.4209 55.6673 37.7375 55.3507 38.1279 55.3507C38.5184 55.3507 38.835 55.6673 38.835 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 56.0577C57.2178 56.4482 56.9012 56.7648 56.5107 56.7648C56.1203 56.7648 55.8037 56.4482 55.8037 56.0577C55.8037 55.6673 56.1203 55.3507 56.5107 55.3507C56.9012 55.3507 57.2178 55.6673 57.2178 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 56.0577C75.6016 56.4482 75.285 56.7648 74.8945 56.7648C74.5041 56.7648 74.1875 56.4482 74.1875 56.0577C74.1875 55.6673 74.5041 55.3507 74.8945 55.3507C75.285 55.3507 75.6016 55.6673 75.6016 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 56.0577C93.9844 56.4482 93.6678 56.7648 93.2773 56.7648C92.8869 56.7648 92.5703 56.4482 92.5703 56.0577C92.5703 55.6673 92.8869 55.3507 93.2773 55.3507C93.6678 55.3507 93.9844 55.6673 93.9844 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 56.0577C112.367 56.4482 112.051 56.7648 111.66 56.7648C111.27 56.7648 110.953 56.4482 110.953 56.0577C110.953 55.6673 111.27 55.3507 111.66 55.3507C112.051 55.3507 112.367 55.6673 112.367 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 56.0577C130.75 56.4482 130.433 56.7648 130.043 56.7648C129.653 56.7648 129.336 56.4482 129.336 56.0577C129.336 55.6673 129.653 55.3507 130.043 55.3507C130.433 55.3507 130.75 55.6673 130.75 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 56.0577C149.133 56.4482 148.816 56.7648 148.426 56.7648C148.036 56.7648 147.719 56.4482 147.719 56.0577C147.719 55.6673 148.036 55.3507 148.426 55.3507C148.816 55.3507 149.133 55.6673 149.133 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 56.0577C167.516 56.4482 167.199 56.7648 166.809 56.7648C166.418 56.7648 166.102 56.4482 166.102 56.0577C166.102 55.6673 166.418 55.3507 166.809 55.3507C167.199 55.3507 167.516 55.6673 167.516 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 74.4409C2.06935 74.8313 1.75279 75.148 1.36231 75.148C0.971825 75.148 0.655273 74.8313 0.655273 74.4409C0.655273 74.0505 0.971825 73.7339 1.36231 73.7339C1.75279 73.7339 2.06935 74.0505 2.06935 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 74.4409C20.4522 74.8313 20.1355 75.148 19.7451 75.148C19.3547 75.148 19.0381 74.8313 19.0381 74.4409C19.0381 74.0505 19.3547 73.7339 19.7451 73.7339C20.1355 73.7339 20.4522 74.0505 20.4522 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 74.4409C38.835 74.8313 38.5184 75.148 38.1279 75.148C37.7375 75.148 37.4209 74.8313 37.4209 74.4409C37.4209 74.0505 37.7375 73.7339 38.1279 73.7339C38.5184 73.7339 38.835 74.0505 38.835 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 74.4409C57.2178 74.8313 56.9012 75.148 56.5107 75.148C56.1203 75.148 55.8037 74.8313 55.8037 74.4409C55.8037 74.0505 56.1203 73.7339 56.5107 73.7339C56.9012 73.7339 57.2178 74.0505 57.2178 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 74.4409C75.6016 74.8313 75.285 75.148 74.8945 75.148C74.5041 75.148 74.1875 74.8313 74.1875 74.4409C74.1875 74.0505 74.5041 73.7339 74.8945 73.7339C75.285 73.7339 75.6016 74.0505 75.6016 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 74.4409C93.9844 74.8313 93.6678 75.148 93.2773 75.148C92.8869 75.148 92.5703 74.8313 92.5703 74.4409C92.5703 74.0505 92.8869 73.7339 93.2773 73.7339C93.6678 73.7339 93.9844 74.0505 93.9844 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 74.4409C112.367 74.8313 112.051 75.148 111.66 75.148C111.27 75.148 110.953 74.8313 110.953 74.4409C110.953 74.0505 111.27 73.7339 111.66 73.7339C112.051 73.7339 112.367 74.0505 112.367 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 74.4409C130.75 74.8313 130.433 75.148 130.043 75.148C129.653 75.148 129.336 74.8313 129.336 74.4409C129.336 74.0505 129.653 73.7339 130.043 73.7339C130.433 73.7339 130.75 74.0505 130.75 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 74.4409C149.133 74.8313 148.816 75.148 148.426 75.148C148.036 75.148 147.719 74.8313 147.719 74.4409C147.719 74.0505 148.036 73.7339 148.426 73.7339C148.816 73.7339 149.133 74.0505 149.133 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 74.4409C167.516 74.8313 167.199 75.148 166.809 75.148C166.418 75.148 166.102 74.8313 166.102 74.4409C166.102 74.0505 166.418 73.7339 166.809 73.7339C167.199 73.7339 167.516 74.0505 167.516 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 92.824C2.06935 93.2145 1.75279 93.5311 1.36231 93.5311C0.971825 93.5311 0.655273 93.2145 0.655273 92.824C0.655273 92.4336 0.971825 92.117 1.36231 92.117C1.75279 92.117 2.06935 92.4336 2.06935 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 92.824C20.4522 93.2145 20.1355 93.5311 19.7451 93.5311C19.3547 93.5311 19.0381 93.2145 19.0381 92.824C19.0381 92.4336 19.3547 92.117 19.7451 92.117C20.1355 92.117 20.4522 92.4336 20.4522 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 92.824C38.835 93.2145 38.5184 93.5311 38.1279 93.5311C37.7375 93.5311 37.4209 93.2145 37.4209 92.824C37.4209 92.4336 37.7375 92.117 38.1279 92.117C38.5184 92.117 38.835 92.4336 38.835 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 92.824C57.2178 93.2145 56.9012 93.5311 56.5107 93.5311C56.1203 93.5311 55.8037 93.2145 55.8037 92.824C55.8037 92.4336 56.1203 92.117 56.5107 92.117C56.9012 92.117 57.2178 92.4336 57.2178 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 92.824C75.6016 93.2145 75.285 93.5311 74.8945 93.5311C74.5041 93.5311 74.1875 93.2145 74.1875 92.824C74.1875 92.4336 74.5041 92.117 74.8945 92.117C75.285 92.117 75.6016 92.4336 75.6016 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 92.824C93.9844 93.2145 93.6678 93.5311 93.2773 93.5311C92.8869 93.5311 92.5703 93.2145 92.5703 92.824C92.5703 92.4336 92.8869 92.117 93.2773 92.117C93.6678 92.117 93.9844 92.4336 93.9844 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 92.824C112.367 93.2145 112.051 93.5311 111.66 93.5311C111.27 93.5311 110.953 93.2145 110.953 92.824C110.953 92.4336 111.27 92.117 111.66 92.117C112.051 92.117 112.367 92.4336 112.367 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 92.824C130.75 93.2145 130.433 93.5311 130.043 93.5311C129.653 93.5311 129.336 93.2145 129.336 92.824C129.336 92.4336 129.653 92.117 130.043 92.117C130.433 92.117 130.75 92.4336 130.75 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 92.824C149.133 93.2145 148.816 93.5311 148.426 93.5311C148.036 93.5311 147.719 93.2145 147.719 92.824C147.719 92.4336 148.036 92.117 148.426 92.117C148.816 92.117 149.133 92.4336 149.133 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 92.824C167.516 93.2145 167.199 93.5311 166.809 93.5311C166.418 93.5311 166.102 93.2145 166.102 92.824C166.102 92.4336 166.418 92.117 166.809 92.117C167.199 92.117 167.516 92.4336 167.516 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 111.207C2.06935 111.597 1.75279 111.914 1.36231 111.914C0.971825 111.914 0.655273 111.597 0.655273 111.207C0.655273 110.817 0.971825 110.5 1.36231 110.5C1.75279 110.5 2.06935 110.817 2.06935 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 111.207C20.4522 111.597 20.1355 111.914 19.7451 111.914C19.3547 111.914 19.0381 111.597 19.0381 111.207C19.0381 110.817 19.3547 110.5 19.7451 110.5C20.1355 110.5 20.4522 110.817 20.4522 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 111.207C38.835 111.597 38.5184 111.914 38.1279 111.914C37.7375 111.914 37.4209 111.597 37.4209 111.207C37.4209 110.817 37.7375 110.5 38.1279 110.5C38.5184 110.5 38.835 110.817 38.835 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 111.207C57.2178 111.597 56.9012 111.914 56.5107 111.914C56.1203 111.914 55.8037 111.597 55.8037 111.207C55.8037 110.817 56.1203 110.5 56.5107 110.5C56.9012 110.5 57.2178 110.817 57.2178 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 111.207C75.6016 111.597 75.285 111.914 74.8945 111.914C74.5041 111.914 74.1875 111.597 74.1875 111.207C74.1875 110.817 74.5041 110.5 74.8945 110.5C75.285 110.5 75.6016 110.817 75.6016 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 111.207C93.9844 111.597 93.6678 111.914 93.2773 111.914C92.8869 111.914 92.5703 111.597 92.5703 111.207C92.5703 110.817 92.8869 110.5 93.2773 110.5C93.6678 110.5 93.9844 110.817 93.9844 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 111.207C112.367 111.597 112.051 111.914 111.66 111.914C111.27 111.914 110.953 111.597 110.953 111.207C110.953 110.817 111.27 110.5 111.66 110.5C112.051 110.5 112.367 110.817 112.367 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 111.207C130.75 111.597 130.433 111.914 130.043 111.914C129.653 111.914 129.336 111.597 129.336 111.207C129.336 110.817 129.653 110.5 130.043 110.5C130.433 110.5 130.75 110.817 130.75 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 111.207C149.133 111.597 148.816 111.914 148.426 111.914C148.036 111.914 147.719 111.597 147.719 111.207C147.719 110.817 148.036 110.5 148.426 110.5C148.816 110.5 149.133 110.817 149.133 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 111.207C167.516 111.597 167.199 111.914 166.809 111.914C166.418 111.914 166.102 111.597 166.102 111.207C166.102 110.817 166.418 110.5 166.809 110.5C167.199 110.5 167.516 110.817 167.516 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 129.59C2.06935 129.98 1.75279 130.297 1.36231 130.297C0.971825 130.297 0.655273 129.98 0.655273 129.59C0.655273 129.199 0.971825 128.883 1.36231 128.883C1.75279 128.883 2.06935 129.199 2.06935 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 129.59C20.4522 129.98 20.1355 130.297 19.7451 130.297C19.3547 130.297 19.0381 129.98 19.0381 129.59C19.0381 129.199 19.3547 128.883 19.7451 128.883C20.1355 128.883 20.4522 129.199 20.4522 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 129.59C38.835 129.98 38.5184 130.297 38.1279 130.297C37.7375 130.297 37.4209 129.98 37.4209 129.59C37.4209 129.199 37.7375 128.883 38.1279 128.883C38.5184 128.883 38.835 129.199 38.835 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 129.59C57.2178 129.98 56.9012 130.297 56.5107 130.297C56.1203 130.297 55.8037 129.98 55.8037 129.59C55.8037 129.199 56.1203 128.883 56.5107 128.883C56.9012 128.883 57.2178 129.199 57.2178 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 129.59C75.6016 129.98 75.285 130.297 74.8945 130.297C74.5041 130.297 74.1875 129.98 74.1875 129.59C74.1875 129.199 74.5041 128.883 74.8945 128.883C75.285 128.883 75.6016 129.199 75.6016 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 129.59C93.9844 129.98 93.6678 130.297 93.2773 130.297C92.8869 130.297 92.5703 129.98 92.5703 129.59C92.5703 129.199 92.8869 128.883 93.2773 128.883C93.6678 128.883 93.9844 129.199 93.9844 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 129.59C112.367 129.98 112.051 130.297 111.66 130.297C111.27 130.297 110.953 129.98 110.953 129.59C110.953 129.199 111.27 128.883 111.66 128.883C112.051 128.883 112.367 129.199 112.367 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 129.59C130.75 129.98 130.433 130.297 130.043 130.297C129.653 130.297 129.336 129.98 129.336 129.59C129.336 129.199 129.653 128.883 130.043 128.883C130.433 128.883 130.75 129.199 130.75 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 129.59C149.133 129.98 148.816 130.297 148.426 130.297C148.036 130.297 147.719 129.98 147.719 129.59C147.719 129.199 148.036 128.883 148.426 128.883C148.816 128.883 149.133 129.199 149.133 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 129.59C167.516 129.98 167.199 130.297 166.809 130.297C166.418 130.297 166.102 129.98 166.102 129.59C166.102 129.199 166.418 128.883 166.809 128.883C167.199 128.883 167.516 129.199 167.516 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 147.973C2.06935 148.363 1.75279 148.68 1.36231 148.68C0.971825 148.68 0.655273 148.363 0.655273 147.973C0.655273 147.583 0.971825 147.266 1.36231 147.266C1.75279 147.266 2.06935 147.583 2.06935 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 147.973C20.4522 148.363 20.1355 148.68 19.7451 148.68C19.3547 148.68 19.0381 148.363 19.0381 147.973C19.0381 147.583 19.3547 147.266 19.7451 147.266C20.1355 147.266 20.4522 147.583 20.4522 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 147.973C38.835 148.363 38.5184 148.68 38.1279 148.68C37.7375 148.68 37.4209 148.363 37.4209 147.973C37.4209 147.583 37.7375 147.266 38.1279 147.266C38.5184 147.266 38.835 147.583 38.835 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 147.973C57.2178 148.363 56.9012 148.68 56.5107 148.68C56.1203 148.68 55.8037 148.363 55.8037 147.973C55.8037 147.583 56.1203 147.266 56.5107 147.266C56.9012 147.266 57.2178 147.583 57.2178 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 147.973C75.6016 148.363 75.285 148.68 74.8945 148.68C74.5041 148.68 74.1875 148.363 74.1875 147.973C74.1875 147.583 74.5041 147.266 74.8945 147.266C75.285 147.266 75.6016 147.583 75.6016 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 147.973C93.9844 148.363 93.6678 148.68 93.2773 148.68C92.8869 148.68 92.5703 148.363 92.5703 147.973C92.5703 147.583 92.8869 147.266 93.2773 147.266C93.6678 147.266 93.9844 147.583 93.9844 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 147.973C112.367 148.363 112.051 148.68 111.66 148.68C111.27 148.68 110.953 148.363 110.953 147.973C110.953 147.583 111.27 147.266 111.66 147.266C112.051 147.266 112.367 147.583 112.367 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 147.973C130.75 148.363 130.433 148.68 130.043 148.68C129.653 148.68 129.336 148.363 129.336 147.973C129.336 147.583 129.653 147.266 130.043 147.266C130.433 147.266 130.75 147.583 130.75 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 147.973C149.133 148.363 148.816 148.68 148.426 148.68C148.036 148.68 147.719 148.363 147.719 147.973C147.719 147.583 148.036 147.266 148.426 147.266C148.816 147.266 149.133 147.583 149.133 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 147.973C167.516 148.363 167.199 148.68 166.809 148.68C166.418 148.68 166.102 148.363 166.102 147.973C166.102 147.583 166.418 147.266 166.809 147.266C167.199 147.266 167.516 147.583 167.516 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 166.356C2.06935 166.746 1.75279 167.063 1.36231 167.063C0.971825 167.063 0.655273 166.746 0.655273 166.356C0.655273 165.966 0.971825 165.649 1.36231 165.649C1.75279 165.649 2.06935 165.966 2.06935 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 166.356C20.4522 166.746 20.1355 167.063 19.7451 167.063C19.3547 167.063 19.0381 166.746 19.0381 166.356C19.0381 165.966 19.3547 165.649 19.7451 165.649C20.1355 165.649 20.4522 165.966 20.4522 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 166.356C38.835 166.746 38.5184 167.063 38.1279 167.063C37.7375 167.063 37.4209 166.746 37.4209 166.356C37.4209 165.966 37.7375 165.649 38.1279 165.649C38.5184 165.649 38.835 165.966 38.835 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 166.356C57.2178 166.746 56.9012 167.063 56.5107 167.063C56.1203 167.063 55.8037 166.746 55.8037 166.356C55.8037 165.966 56.1203 165.649 56.5107 165.649C56.9012 165.649 57.2178 165.966 57.2178 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 166.356C75.6016 166.746 75.285 167.063 74.8945 167.063C74.5041 167.063 74.1875 166.746 74.1875 166.356C74.1875 165.966 74.5041 165.649 74.8945 165.649C75.285 165.649 75.6016 165.966 75.6016 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 166.356C93.9844 166.746 93.6678 167.063 93.2773 167.063C92.8869 167.063 92.5703 166.746 92.5703 166.356C92.5703 165.966 92.8869 165.649 93.2773 165.649C93.6678 165.649 93.9844 165.966 93.9844 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 166.356C112.367 166.746 112.051 167.063 111.66 167.063C111.27 167.063 110.953 166.746 110.953 166.356C110.953 165.966 111.27 165.649 111.66 165.649C112.051 165.649 112.367 165.966 112.367 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 166.356C130.75 166.746 130.433 167.063 130.043 167.063C129.653 167.063 129.336 166.746 129.336 166.356C129.336 165.966 129.653 165.649 130.043 165.649C130.433 165.649 130.75 165.966 130.75 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 166.356C149.133 166.746 148.816 167.063 148.426 167.063C148.036 167.063 147.719 166.746 147.719 166.356C147.719 165.966 148.036 165.649 148.426 165.649C148.816 165.649 149.133 165.966 149.133 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 166.356C167.516 166.746 167.199 167.063 166.809 167.063C166.418 167.063 166.102 166.746 166.102 166.356C166.102 165.966 166.418 165.649 166.809 165.649C167.199 165.649 167.516 165.966 167.516 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 184.739C2.06935 185.129 1.75279 185.446 1.36231 185.446C0.971825 185.446 0.655273 185.129 0.655273 184.739C0.655273 184.348 0.971825 184.032 1.36231 184.032C1.75279 184.032 2.06935 184.348 2.06935 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 184.739C20.4522 185.129 20.1355 185.446 19.7451 185.446C19.3547 185.446 19.0381 185.129 19.0381 184.739C19.0381 184.348 19.3547 184.032 19.7451 184.032C20.1355 184.032 20.4522 184.348 20.4522 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 184.739C38.835 185.129 38.5184 185.446 38.1279 185.446C37.7375 185.446 37.4209 185.129 37.4209 184.739C37.4209 184.348 37.7375 184.032 38.1279 184.032C38.5184 184.032 38.835 184.348 38.835 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 184.739C57.2178 185.129 56.9012 185.446 56.5107 185.446C56.1203 185.446 55.8037 185.129 55.8037 184.739C55.8037 184.348 56.1203 184.032 56.5107 184.032C56.9012 184.032 57.2178 184.348 57.2178 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 184.739C75.6016 185.129 75.285 185.446 74.8945 185.446C74.5041 185.446 74.1875 185.129 74.1875 184.739C74.1875 184.348 74.5041 184.032 74.8945 184.032C75.285 184.032 75.6016 184.348 75.6016 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 184.739C93.9844 185.129 93.6678 185.446 93.2773 185.446C92.8869 185.446 92.5703 185.129 92.5703 184.739C92.5703 184.348 92.8869 184.032 93.2773 184.032C93.6678 184.032 93.9844 184.348 93.9844 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 184.739C112.367 185.129 112.051 185.446 111.66 185.446C111.27 185.446 110.953 185.129 110.953 184.739C110.953 184.348 111.27 184.032 111.66 184.032C112.051 184.032 112.367 184.348 112.367 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 184.739C130.75 185.129 130.433 185.446 130.043 185.446C129.653 185.446 129.336 185.129 129.336 184.739C129.336 184.348 129.653 184.032 130.043 184.032C130.433 184.032 130.75 184.348 130.75 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 184.739C149.133 185.129 148.816 185.446 148.426 185.446C148.036 185.446 147.719 185.129 147.719 184.739C147.719 184.348 148.036 184.032 148.426 184.032C148.816 184.032 149.133 184.348 149.133 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 184.739C167.516 185.129 167.199 185.446 166.809 185.446C166.418 185.446 166.102 185.129 166.102 184.739C166.102 184.348 166.418 184.032 166.809 184.032C167.199 184.032 167.516 184.348 167.516 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 203.121C2.06935 203.512 1.75279 203.829 1.36231 203.829C0.971825 203.829 0.655273 203.512 0.655273 203.121C0.655273 202.731 0.971825 202.414 1.36231 202.414C1.75279 202.414 2.06935 202.731 2.06935 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 203.121C20.4522 203.512 20.1355 203.829 19.7451 203.829C19.3547 203.829 19.0381 203.512 19.0381 203.121C19.0381 202.731 19.3547 202.414 19.7451 202.414C20.1355 202.414 20.4522 202.731 20.4522 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 203.121C38.835 203.512 38.5184 203.829 38.1279 203.829C37.7375 203.829 37.4209 203.512 37.4209 203.121C37.4209 202.731 37.7375 202.414 38.1279 202.414C38.5184 202.414 38.835 202.731 38.835 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 203.121C57.2178 203.512 56.9012 203.829 56.5107 203.829C56.1203 203.829 55.8037 203.512 55.8037 203.121C55.8037 202.731 56.1203 202.414 56.5107 202.414C56.9012 202.414 57.2178 202.731 57.2178 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 203.121C75.6016 203.512 75.285 203.829 74.8945 203.829C74.5041 203.829 74.1875 203.512 74.1875 203.121C74.1875 202.731 74.5041 202.414 74.8945 202.414C75.285 202.414 75.6016 202.731 75.6016 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 203.121C93.9844 203.512 93.6678 203.829 93.2773 203.829C92.8869 203.829 92.5703 203.512 92.5703 203.121C92.5703 202.731 92.8869 202.414 93.2773 202.414C93.6678 202.414 93.9844 202.731 93.9844 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 203.121C112.367 203.512 112.051 203.829 111.66 203.829C111.27 203.829 110.953 203.512 110.953 203.121C110.953 202.731 111.27 202.414 111.66 202.414C112.051 202.414 112.367 202.731 112.367 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 203.121C130.75 203.512 130.433 203.829 130.043 203.829C129.653 203.829 129.336 203.512 129.336 203.121C129.336 202.731 129.653 202.414 130.043 202.414C130.433 202.414 130.75 202.731 130.75 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 203.121C149.133 203.512 148.816 203.829 148.426 203.829C148.036 203.829 147.719 203.512 147.719 203.121C147.719 202.731 148.036 202.414 148.426 202.414C148.816 202.414 149.133 202.731 149.133 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 203.121C167.516 203.512 167.199 203.829 166.809 203.829C166.418 203.829 166.102 203.512 166.102 203.121C166.102 202.731 166.418 202.414 166.809 202.414C167.199 202.414 167.516 202.731 167.516 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 221.505C2.06935 221.895 1.75279 222.212 1.36231 222.212C0.971825 222.212 0.655273 221.895 0.655273 221.505C0.655273 221.114 0.971825 220.798 1.36231 220.798C1.75279 220.798 2.06935 221.114 2.06935 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 221.505C20.4522 221.895 20.1355 222.212 19.7451 222.212C19.3547 222.212 19.0381 221.895 19.0381 221.505C19.0381 221.114 19.3547 220.798 19.7451 220.798C20.1355 220.798 20.4522 221.114 20.4522 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 221.505C38.835 221.895 38.5184 222.212 38.1279 222.212C37.7375 222.212 37.4209 221.895 37.4209 221.505C37.4209 221.114 37.7375 220.798 38.1279 220.798C38.5184 220.798 38.835 221.114 38.835 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 221.505C57.2178 221.895 56.9012 222.212 56.5107 222.212C56.1203 222.212 55.8037 221.895 55.8037 221.505C55.8037 221.114 56.1203 220.798 56.5107 220.798C56.9012 220.798 57.2178 221.114 57.2178 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 221.505C75.6016 221.895 75.285 222.212 74.8945 222.212C74.5041 222.212 74.1875 221.895 74.1875 221.505C74.1875 221.114 74.5041 220.798 74.8945 220.798C75.285 220.798 75.6016 221.114 75.6016 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 221.505C93.9844 221.895 93.6678 222.212 93.2773 222.212C92.8869 222.212 92.5703 221.895 92.5703 221.505C92.5703 221.114 92.8869 220.798 93.2773 220.798C93.6678 220.798 93.9844 221.114 93.9844 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 221.505C112.367 221.895 112.051 222.212 111.66 222.212C111.27 222.212 110.953 221.895 110.953 221.505C110.953 221.114 111.27 220.798 111.66 220.798C112.051 220.798 112.367 221.114 112.367 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 221.505C130.75 221.895 130.433 222.212 130.043 222.212C129.653 222.212 129.336 221.895 129.336 221.505C129.336 221.114 129.653 220.798 130.043 220.798C130.433 220.798 130.75 221.114 130.75 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 221.505C149.133 221.895 148.816 222.212 148.426 222.212C148.036 222.212 147.719 221.895 147.719 221.505C147.719 221.114 148.036 220.798 148.426 220.798C148.816 220.798 149.133 221.114 149.133 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 221.505C167.516 221.895 167.199 222.212 166.809 222.212C166.418 222.212 166.102 221.895 166.102 221.505C166.102 221.114 166.418 220.798 166.809 220.798C167.199 220.798 167.516 221.114 167.516 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06935 239.888C2.06935 240.278 1.75279 240.595 1.36231 240.595C0.971825 240.595 0.655273 240.278 0.655273 239.888C0.655273 239.497 0.971825 239.181 1.36231 239.181C1.75279 239.181 2.06935 239.497 2.06935 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4522 239.888C20.4522 240.278 20.1355 240.595 19.7451 240.595C19.3547 240.595 19.0381 240.278 19.0381 239.888C19.0381 239.497 19.3547 239.181 19.7451 239.181C20.1355 239.181 20.4522 239.497 20.4522 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.835 239.888C38.835 240.278 38.5184 240.595 38.1279 240.595C37.7375 240.595 37.4209 240.278 37.4209 239.888C37.4209 239.497 37.7375 239.181 38.1279 239.181C38.5184 239.181 38.835 239.497 38.835 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2178 239.888C57.2178 240.278 56.9012 240.595 56.5107 240.595C56.1203 240.595 55.8037 240.278 55.8037 239.888C55.8037 239.497 56.1203 239.181 56.5107 239.181C56.9012 239.181 57.2178 239.497 57.2178 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6016 239.888C75.6016 240.278 75.285 240.595 74.8945 240.595C74.5041 240.595 74.1875 240.278 74.1875 239.888C74.1875 239.497 74.5041 239.181 74.8945 239.181C75.285 239.181 75.6016 239.497 75.6016 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9844 239.888C93.9844 240.278 93.6678 240.595 93.2773 240.595C92.8869 240.595 92.5703 240.278 92.5703 239.888C92.5703 239.497 92.8869 239.181 93.2773 239.181C93.6678 239.181 93.9844 239.497 93.9844 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.367 239.888C112.367 240.278 112.051 240.595 111.66 240.595C111.27 240.595 110.953 240.278 110.953 239.888C110.953 239.497 111.27 239.181 111.66 239.181C112.051 239.181 112.367 239.497 112.367 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75 239.888C130.75 240.278 130.433 240.595 130.043 240.595C129.653 240.595 129.336 240.278 129.336 239.888C129.336 239.497 129.653 239.181 130.043 239.181C130.433 239.181 130.75 239.497 130.75 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.133 239.888C149.133 240.278 148.816 240.595 148.426 240.595C148.036 240.595 147.719 240.278 147.719 239.888C147.719 239.497 148.036 239.181 148.426 239.181C148.816 239.181 149.133 239.497 149.133 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 239.888C167.516 240.278 167.199 240.595 166.809 240.595C166.418 240.595 166.102 240.278 166.102 239.888C166.102 239.497 166.418 239.181 166.809 239.181C167.199 239.181 167.516 239.497 167.516 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 0.909124C349.932 1.29961 350.248 1.61616 350.639 1.61616C351.029 1.61616 351.346 1.29961 351.346 0.909124C351.346 0.518639 351.029 0.202087 350.639 0.202087C350.248 0.202087 349.932 0.518639 349.932 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 0.909124C331.548 1.29961 331.865 1.61616 332.255 1.61616C332.645 1.61616 332.962 1.29961 332.962 0.909124C332.962 0.518639 332.645 0.202087 332.255 0.202087C331.865 0.202087 331.548 0.518639 331.548 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 0.909124C313.165 1.29961 313.482 1.61616 313.872 1.61616C314.262 1.61616 314.579 1.29961 314.579 0.909124C314.579 0.518639 314.262 0.202087 313.872 0.202087C313.482 0.202087 313.165 0.518639 313.165 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 0.909124C294.782 1.29961 295.099 1.61616 295.489 1.61616C295.88 1.61616 296.196 1.29961 296.196 0.909124C296.196 0.518639 295.88 0.202087 295.489 0.202087C295.099 0.202087 294.782 0.518639 294.782 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 0.909124C276.399 1.29961 276.716 1.61616 277.106 1.61616C277.497 1.61616 277.813 1.29961 277.813 0.909124C277.813 0.518639 277.497 0.202087 277.106 0.202087C276.716 0.202087 276.399 0.518639 276.399 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 0.909124C258.017 1.29961 258.333 1.61616 258.724 1.61616C259.114 1.61616 259.431 1.29961 259.431 0.909124C259.431 0.518639 259.114 0.202087 258.724 0.202087C258.333 0.202087 258.017 0.518639 258.017 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 0.909124C239.634 1.29961 239.951 1.61616 240.341 1.61616C240.731 1.61616 241.048 1.29961 241.048 0.909124C241.048 0.518639 240.731 0.202087 240.341 0.202087C239.951 0.202087 239.634 0.518639 239.634 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 0.909124C221.251 1.29961 221.568 1.61616 221.958 1.61616C222.348 1.61616 222.665 1.29961 222.665 0.909124C222.665 0.518639 222.348 0.202087 221.958 0.202087C221.568 0.202087 221.251 0.518639 221.251 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 0.909124C202.868 1.29961 203.185 1.61616 203.575 1.61616C203.965 1.61616 204.282 1.29961 204.282 0.909124C204.282 0.518639 203.965 0.202087 203.575 0.202087C203.185 0.202087 202.868 0.518639 202.868 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 0.909124C184.484 1.29961 184.801 1.61616 185.191 1.61616C185.582 1.61616 185.898 1.29961 185.898 0.909124C185.898 0.518639 185.582 0.202087 185.191 0.202087C184.801 0.202087 184.484 0.518639 184.484 0.909124Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 19.2921C349.932 19.6825 350.248 19.9992 350.639 19.9992C351.029 19.9992 351.346 19.6825 351.346 19.2921C351.346 18.9017 351.029 18.5851 350.639 18.5851C350.248 18.5851 349.932 18.9017 349.932 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 19.2921C331.548 19.6825 331.865 19.9992 332.255 19.9992C332.645 19.9992 332.962 19.6825 332.962 19.2921C332.962 18.9017 332.645 18.5851 332.255 18.5851C331.865 18.5851 331.548 18.9017 331.548 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 19.2921C313.165 19.6825 313.482 19.9992 313.872 19.9992C314.262 19.9992 314.579 19.6825 314.579 19.2921C314.579 18.9017 314.262 18.5851 313.872 18.5851C313.482 18.5851 313.165 18.9017 313.165 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 19.2921C294.782 19.6825 295.099 19.9992 295.489 19.9992C295.88 19.9992 296.196 19.6825 296.196 19.2921C296.196 18.9017 295.88 18.5851 295.489 18.5851C295.099 18.5851 294.782 18.9017 294.782 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 19.2921C276.399 19.6825 276.716 19.9992 277.106 19.9992C277.497 19.9992 277.813 19.6825 277.813 19.2921C277.813 18.9017 277.497 18.5851 277.106 18.5851C276.716 18.5851 276.399 18.9017 276.399 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 19.2921C258.017 19.6825 258.333 19.9992 258.724 19.9992C259.114 19.9992 259.431 19.6825 259.431 19.2921C259.431 18.9017 259.114 18.5851 258.724 18.5851C258.333 18.5851 258.017 18.9017 258.017 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 19.2921C239.634 19.6825 239.951 19.9992 240.341 19.9992C240.731 19.9992 241.048 19.6825 241.048 19.2921C241.048 18.9017 240.731 18.5851 240.341 18.5851C239.951 18.5851 239.634 18.9017 239.634 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 19.2921C221.251 19.6825 221.568 19.9992 221.958 19.9992C222.348 19.9992 222.665 19.6825 222.665 19.2921C222.665 18.9017 222.348 18.5851 221.958 18.5851C221.568 18.5851 221.251 18.9017 221.251 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 19.2921C202.868 19.6825 203.185 19.9992 203.575 19.9992C203.965 19.9992 204.282 19.6825 204.282 19.2921C204.282 18.9017 203.965 18.5851 203.575 18.5851C203.185 18.5851 202.868 18.9017 202.868 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 19.2921C184.484 19.6825 184.801 19.9992 185.191 19.9992C185.582 19.9992 185.898 19.6825 185.898 19.2921C185.898 18.9017 185.582 18.5851 185.191 18.5851C184.801 18.5851 184.484 18.9017 184.484 19.2921Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 37.6752C349.932 38.0657 350.248 38.3823 350.639 38.3823C351.029 38.3823 351.346 38.0657 351.346 37.6752C351.346 37.2848 351.029 36.9682 350.639 36.9682C350.248 36.9682 349.932 37.2848 349.932 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 37.6752C331.548 38.0657 331.865 38.3823 332.255 38.3823C332.645 38.3823 332.962 38.0657 332.962 37.6752C332.962 37.2848 332.645 36.9682 332.255 36.9682C331.865 36.9682 331.548 37.2848 331.548 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 37.6752C313.165 38.0657 313.482 38.3823 313.872 38.3823C314.262 38.3823 314.579 38.0657 314.579 37.6752C314.579 37.2848 314.262 36.9682 313.872 36.9682C313.482 36.9682 313.165 37.2848 313.165 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 37.6752C294.782 38.0657 295.099 38.3823 295.489 38.3823C295.88 38.3823 296.196 38.0657 296.196 37.6752C296.196 37.2848 295.88 36.9682 295.489 36.9682C295.099 36.9682 294.782 37.2848 294.782 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 37.6752C276.399 38.0657 276.716 38.3823 277.106 38.3823C277.497 38.3823 277.813 38.0657 277.813 37.6752C277.813 37.2848 277.497 36.9682 277.106 36.9682C276.716 36.9682 276.399 37.2848 276.399 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 37.6752C258.017 38.0657 258.333 38.3823 258.724 38.3823C259.114 38.3823 259.431 38.0657 259.431 37.6752C259.431 37.2848 259.114 36.9682 258.724 36.9682C258.333 36.9682 258.017 37.2848 258.017 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 37.6752C239.634 38.0657 239.951 38.3823 240.341 38.3823C240.731 38.3823 241.048 38.0657 241.048 37.6752C241.048 37.2848 240.731 36.9682 240.341 36.9682C239.951 36.9682 239.634 37.2848 239.634 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 37.6752C221.251 38.0657 221.568 38.3823 221.958 38.3823C222.348 38.3823 222.665 38.0657 222.665 37.6752C222.665 37.2848 222.348 36.9682 221.958 36.9682C221.568 36.9682 221.251 37.2848 221.251 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 37.6752C202.868 38.0657 203.185 38.3823 203.575 38.3823C203.965 38.3823 204.282 38.0657 204.282 37.6752C204.282 37.2848 203.965 36.9682 203.575 36.9682C203.185 36.9682 202.868 37.2848 202.868 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 37.6752C184.484 38.0657 184.801 38.3823 185.191 38.3823C185.582 38.3823 185.898 38.0657 185.898 37.6752C185.898 37.2848 185.582 36.9682 185.191 36.9682C184.801 36.9682 184.484 37.2848 184.484 37.6752Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 56.0577C349.932 56.4482 350.248 56.7648 350.639 56.7648C351.029 56.7648 351.346 56.4482 351.346 56.0577C351.346 55.6673 351.029 55.3507 350.639 55.3507C350.248 55.3507 349.932 55.6673 349.932 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 56.0577C331.548 56.4482 331.865 56.7648 332.255 56.7648C332.645 56.7648 332.962 56.4482 332.962 56.0577C332.962 55.6673 332.645 55.3507 332.255 55.3507C331.865 55.3507 331.548 55.6673 331.548 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 56.0577C313.165 56.4482 313.482 56.7648 313.872 56.7648C314.262 56.7648 314.579 56.4482 314.579 56.0577C314.579 55.6673 314.262 55.3507 313.872 55.3507C313.482 55.3507 313.165 55.6673 313.165 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 56.0577C294.782 56.4482 295.099 56.7648 295.489 56.7648C295.88 56.7648 296.196 56.4482 296.196 56.0577C296.196 55.6673 295.88 55.3507 295.489 55.3507C295.099 55.3507 294.782 55.6673 294.782 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 56.0577C276.399 56.4482 276.716 56.7648 277.106 56.7648C277.497 56.7648 277.813 56.4482 277.813 56.0577C277.813 55.6673 277.497 55.3507 277.106 55.3507C276.716 55.3507 276.399 55.6673 276.399 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 56.0577C258.017 56.4482 258.333 56.7648 258.724 56.7648C259.114 56.7648 259.431 56.4482 259.431 56.0577C259.431 55.6673 259.114 55.3507 258.724 55.3507C258.333 55.3507 258.017 55.6673 258.017 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 56.0577C239.634 56.4482 239.951 56.7648 240.341 56.7648C240.731 56.7648 241.048 56.4482 241.048 56.0577C241.048 55.6673 240.731 55.3507 240.341 55.3507C239.951 55.3507 239.634 55.6673 239.634 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 56.0577C221.251 56.4482 221.568 56.7648 221.958 56.7648C222.348 56.7648 222.665 56.4482 222.665 56.0577C222.665 55.6673 222.348 55.3507 221.958 55.3507C221.568 55.3507 221.251 55.6673 221.251 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 56.0577C202.868 56.4482 203.185 56.7648 203.575 56.7648C203.965 56.7648 204.282 56.4482 204.282 56.0577C204.282 55.6673 203.965 55.3507 203.575 55.3507C203.185 55.3507 202.868 55.6673 202.868 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 56.0577C184.484 56.4482 184.801 56.7648 185.191 56.7648C185.582 56.7648 185.898 56.4482 185.898 56.0577C185.898 55.6673 185.582 55.3507 185.191 55.3507C184.801 55.3507 184.484 55.6673 184.484 56.0577Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 74.4409C349.932 74.8313 350.248 75.148 350.639 75.148C351.029 75.148 351.346 74.8313 351.346 74.4409C351.346 74.0505 351.029 73.7339 350.639 73.7339C350.248 73.7339 349.932 74.0505 349.932 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 74.4409C331.548 74.8313 331.865 75.148 332.255 75.148C332.645 75.148 332.962 74.8313 332.962 74.4409C332.962 74.0505 332.645 73.7339 332.255 73.7339C331.865 73.7339 331.548 74.0505 331.548 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 74.4409C313.165 74.8313 313.482 75.148 313.872 75.148C314.262 75.148 314.579 74.8313 314.579 74.4409C314.579 74.0505 314.262 73.7339 313.872 73.7339C313.482 73.7339 313.165 74.0505 313.165 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 74.4409C294.782 74.8313 295.099 75.148 295.489 75.148C295.88 75.148 296.196 74.8313 296.196 74.4409C296.196 74.0505 295.88 73.7339 295.489 73.7339C295.099 73.7339 294.782 74.0505 294.782 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 74.4409C276.399 74.8313 276.716 75.148 277.106 75.148C277.497 75.148 277.813 74.8313 277.813 74.4409C277.813 74.0505 277.497 73.7339 277.106 73.7339C276.716 73.7339 276.399 74.0505 276.399 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 74.4409C258.017 74.8313 258.333 75.148 258.724 75.148C259.114 75.148 259.431 74.8313 259.431 74.4409C259.431 74.0505 259.114 73.7339 258.724 73.7339C258.333 73.7339 258.017 74.0505 258.017 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 74.4409C239.634 74.8313 239.951 75.148 240.341 75.148C240.731 75.148 241.048 74.8313 241.048 74.4409C241.048 74.0505 240.731 73.7339 240.341 73.7339C239.951 73.7339 239.634 74.0505 239.634 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 74.4409C221.251 74.8313 221.568 75.148 221.958 75.148C222.348 75.148 222.665 74.8313 222.665 74.4409C222.665 74.0505 222.348 73.7339 221.958 73.7339C221.568 73.7339 221.251 74.0505 221.251 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 74.4409C202.868 74.8313 203.185 75.148 203.575 75.148C203.965 75.148 204.282 74.8313 204.282 74.4409C204.282 74.0505 203.965 73.7339 203.575 73.7339C203.185 73.7339 202.868 74.0505 202.868 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 74.4409C184.484 74.8313 184.801 75.148 185.191 75.148C185.582 75.148 185.898 74.8313 185.898 74.4409C185.898 74.0505 185.582 73.7339 185.191 73.7339C184.801 73.7339 184.484 74.0505 184.484 74.4409Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 92.824C349.932 93.2145 350.248 93.5311 350.639 93.5311C351.029 93.5311 351.346 93.2145 351.346 92.824C351.346 92.4336 351.029 92.117 350.639 92.117C350.248 92.117 349.932 92.4336 349.932 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 92.824C331.548 93.2145 331.865 93.5311 332.255 93.5311C332.645 93.5311 332.962 93.2145 332.962 92.824C332.962 92.4336 332.645 92.117 332.255 92.117C331.865 92.117 331.548 92.4336 331.548 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 92.824C313.165 93.2145 313.482 93.5311 313.872 93.5311C314.262 93.5311 314.579 93.2145 314.579 92.824C314.579 92.4336 314.262 92.117 313.872 92.117C313.482 92.117 313.165 92.4336 313.165 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 92.824C294.782 93.2145 295.099 93.5311 295.489 93.5311C295.88 93.5311 296.196 93.2145 296.196 92.824C296.196 92.4336 295.88 92.117 295.489 92.117C295.099 92.117 294.782 92.4336 294.782 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 92.824C276.399 93.2145 276.716 93.5311 277.106 93.5311C277.497 93.5311 277.813 93.2145 277.813 92.824C277.813 92.4336 277.497 92.117 277.106 92.117C276.716 92.117 276.399 92.4336 276.399 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 92.824C258.017 93.2145 258.333 93.5311 258.724 93.5311C259.114 93.5311 259.431 93.2145 259.431 92.824C259.431 92.4336 259.114 92.117 258.724 92.117C258.333 92.117 258.017 92.4336 258.017 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 92.824C239.634 93.2145 239.951 93.5311 240.341 93.5311C240.731 93.5311 241.048 93.2145 241.048 92.824C241.048 92.4336 240.731 92.117 240.341 92.117C239.951 92.117 239.634 92.4336 239.634 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 92.824C221.251 93.2145 221.568 93.5311 221.958 93.5311C222.348 93.5311 222.665 93.2145 222.665 92.824C222.665 92.4336 222.348 92.117 221.958 92.117C221.568 92.117 221.251 92.4336 221.251 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 92.824C202.868 93.2145 203.185 93.5311 203.575 93.5311C203.965 93.5311 204.282 93.2145 204.282 92.824C204.282 92.4336 203.965 92.117 203.575 92.117C203.185 92.117 202.868 92.4336 202.868 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 92.824C184.484 93.2145 184.801 93.5311 185.191 93.5311C185.582 93.5311 185.898 93.2145 185.898 92.824C185.898 92.4336 185.582 92.117 185.191 92.117C184.801 92.117 184.484 92.4336 184.484 92.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 111.207C349.932 111.597 350.248 111.914 350.639 111.914C351.029 111.914 351.346 111.597 351.346 111.207C351.346 110.817 351.029 110.5 350.639 110.5C350.248 110.5 349.932 110.817 349.932 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 111.207C331.548 111.597 331.865 111.914 332.255 111.914C332.645 111.914 332.962 111.597 332.962 111.207C332.962 110.817 332.645 110.5 332.255 110.5C331.865 110.5 331.548 110.817 331.548 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 111.207C313.165 111.597 313.482 111.914 313.872 111.914C314.262 111.914 314.579 111.597 314.579 111.207C314.579 110.817 314.262 110.5 313.872 110.5C313.482 110.5 313.165 110.817 313.165 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 111.207C294.782 111.597 295.099 111.914 295.489 111.914C295.88 111.914 296.196 111.597 296.196 111.207C296.196 110.817 295.88 110.5 295.489 110.5C295.099 110.5 294.782 110.817 294.782 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 111.207C276.399 111.597 276.716 111.914 277.106 111.914C277.497 111.914 277.813 111.597 277.813 111.207C277.813 110.817 277.497 110.5 277.106 110.5C276.716 110.5 276.399 110.817 276.399 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 111.207C258.017 111.597 258.333 111.914 258.724 111.914C259.114 111.914 259.431 111.597 259.431 111.207C259.431 110.817 259.114 110.5 258.724 110.5C258.333 110.5 258.017 110.817 258.017 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 111.207C239.634 111.597 239.951 111.914 240.341 111.914C240.731 111.914 241.048 111.597 241.048 111.207C241.048 110.817 240.731 110.5 240.341 110.5C239.951 110.5 239.634 110.817 239.634 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 111.207C221.251 111.597 221.568 111.914 221.958 111.914C222.348 111.914 222.665 111.597 222.665 111.207C222.665 110.817 222.348 110.5 221.958 110.5C221.568 110.5 221.251 110.817 221.251 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 111.207C202.868 111.597 203.185 111.914 203.575 111.914C203.965 111.914 204.282 111.597 204.282 111.207C204.282 110.817 203.965 110.5 203.575 110.5C203.185 110.5 202.868 110.817 202.868 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 111.207C184.484 111.597 184.801 111.914 185.191 111.914C185.582 111.914 185.898 111.597 185.898 111.207C185.898 110.817 185.582 110.5 185.191 110.5C184.801 110.5 184.484 110.817 184.484 111.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 129.59C349.932 129.98 350.248 130.297 350.639 130.297C351.029 130.297 351.346 129.98 351.346 129.59C351.346 129.199 351.029 128.883 350.639 128.883C350.248 128.883 349.932 129.199 349.932 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 129.59C331.548 129.98 331.865 130.297 332.255 130.297C332.645 130.297 332.962 129.98 332.962 129.59C332.962 129.199 332.645 128.883 332.255 128.883C331.865 128.883 331.548 129.199 331.548 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 129.59C313.165 129.98 313.482 130.297 313.872 130.297C314.262 130.297 314.579 129.98 314.579 129.59C314.579 129.199 314.262 128.883 313.872 128.883C313.482 128.883 313.165 129.199 313.165 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 129.59C294.782 129.98 295.099 130.297 295.489 130.297C295.88 130.297 296.196 129.98 296.196 129.59C296.196 129.199 295.88 128.883 295.489 128.883C295.099 128.883 294.782 129.199 294.782 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 129.59C276.399 129.98 276.716 130.297 277.106 130.297C277.497 130.297 277.813 129.98 277.813 129.59C277.813 129.199 277.497 128.883 277.106 128.883C276.716 128.883 276.399 129.199 276.399 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 129.59C258.017 129.98 258.333 130.297 258.724 130.297C259.114 130.297 259.431 129.98 259.431 129.59C259.431 129.199 259.114 128.883 258.724 128.883C258.333 128.883 258.017 129.199 258.017 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 129.59C239.634 129.98 239.951 130.297 240.341 130.297C240.731 130.297 241.048 129.98 241.048 129.59C241.048 129.199 240.731 128.883 240.341 128.883C239.951 128.883 239.634 129.199 239.634 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 129.59C221.251 129.98 221.568 130.297 221.958 130.297C222.348 130.297 222.665 129.98 222.665 129.59C222.665 129.199 222.348 128.883 221.958 128.883C221.568 128.883 221.251 129.199 221.251 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 129.59C202.868 129.98 203.185 130.297 203.575 130.297C203.965 130.297 204.282 129.98 204.282 129.59C204.282 129.199 203.965 128.883 203.575 128.883C203.185 128.883 202.868 129.199 202.868 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 129.59C184.484 129.98 184.801 130.297 185.191 130.297C185.582 130.297 185.898 129.98 185.898 129.59C185.898 129.199 185.582 128.883 185.191 128.883C184.801 128.883 184.484 129.199 184.484 129.59Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 147.973C349.932 148.363 350.248 148.68 350.639 148.68C351.029 148.68 351.346 148.363 351.346 147.973C351.346 147.583 351.029 147.266 350.639 147.266C350.248 147.266 349.932 147.583 349.932 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 147.973C331.548 148.363 331.865 148.68 332.255 148.68C332.645 148.68 332.962 148.363 332.962 147.973C332.962 147.583 332.645 147.266 332.255 147.266C331.865 147.266 331.548 147.583 331.548 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 147.973C313.165 148.363 313.482 148.68 313.872 148.68C314.262 148.68 314.579 148.363 314.579 147.973C314.579 147.583 314.262 147.266 313.872 147.266C313.482 147.266 313.165 147.583 313.165 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 147.973C294.782 148.363 295.099 148.68 295.489 148.68C295.88 148.68 296.196 148.363 296.196 147.973C296.196 147.583 295.88 147.266 295.489 147.266C295.099 147.266 294.782 147.583 294.782 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 147.973C276.399 148.363 276.716 148.68 277.106 148.68C277.497 148.68 277.813 148.363 277.813 147.973C277.813 147.583 277.497 147.266 277.106 147.266C276.716 147.266 276.399 147.583 276.399 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 147.973C258.017 148.363 258.333 148.68 258.724 148.68C259.114 148.68 259.431 148.363 259.431 147.973C259.431 147.583 259.114 147.266 258.724 147.266C258.333 147.266 258.017 147.583 258.017 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 147.973C239.634 148.363 239.951 148.68 240.341 148.68C240.731 148.68 241.048 148.363 241.048 147.973C241.048 147.583 240.731 147.266 240.341 147.266C239.951 147.266 239.634 147.583 239.634 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 147.973C221.251 148.363 221.568 148.68 221.958 148.68C222.348 148.68 222.665 148.363 222.665 147.973C222.665 147.583 222.348 147.266 221.958 147.266C221.568 147.266 221.251 147.583 221.251 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 147.973C202.868 148.363 203.185 148.68 203.575 148.68C203.965 148.68 204.282 148.363 204.282 147.973C204.282 147.583 203.965 147.266 203.575 147.266C203.185 147.266 202.868 147.583 202.868 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 147.973C184.484 148.363 184.801 148.68 185.191 148.68C185.582 148.68 185.898 148.363 185.898 147.973C185.898 147.583 185.582 147.266 185.191 147.266C184.801 147.266 184.484 147.583 184.484 147.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 166.356C349.932 166.746 350.248 167.063 350.639 167.063C351.029 167.063 351.346 166.746 351.346 166.356C351.346 165.966 351.029 165.649 350.639 165.649C350.248 165.649 349.932 165.966 349.932 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 166.356C331.548 166.746 331.865 167.063 332.255 167.063C332.645 167.063 332.962 166.746 332.962 166.356C332.962 165.966 332.645 165.649 332.255 165.649C331.865 165.649 331.548 165.966 331.548 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 166.356C313.165 166.746 313.482 167.063 313.872 167.063C314.262 167.063 314.579 166.746 314.579 166.356C314.579 165.966 314.262 165.649 313.872 165.649C313.482 165.649 313.165 165.966 313.165 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 166.356C294.782 166.746 295.099 167.063 295.489 167.063C295.88 167.063 296.196 166.746 296.196 166.356C296.196 165.966 295.88 165.649 295.489 165.649C295.099 165.649 294.782 165.966 294.782 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 166.356C276.399 166.746 276.716 167.063 277.106 167.063C277.497 167.063 277.813 166.746 277.813 166.356C277.813 165.966 277.497 165.649 277.106 165.649C276.716 165.649 276.399 165.966 276.399 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 166.356C258.017 166.746 258.333 167.063 258.724 167.063C259.114 167.063 259.431 166.746 259.431 166.356C259.431 165.966 259.114 165.649 258.724 165.649C258.333 165.649 258.017 165.966 258.017 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 166.356C239.634 166.746 239.951 167.063 240.341 167.063C240.731 167.063 241.048 166.746 241.048 166.356C241.048 165.966 240.731 165.649 240.341 165.649C239.951 165.649 239.634 165.966 239.634 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 166.356C221.251 166.746 221.568 167.063 221.958 167.063C222.348 167.063 222.665 166.746 222.665 166.356C222.665 165.966 222.348 165.649 221.958 165.649C221.568 165.649 221.251 165.966 221.251 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 166.356C202.868 166.746 203.185 167.063 203.575 167.063C203.965 167.063 204.282 166.746 204.282 166.356C204.282 165.966 203.965 165.649 203.575 165.649C203.185 165.649 202.868 165.966 202.868 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 166.356C184.484 166.746 184.801 167.063 185.191 167.063C185.582 167.063 185.898 166.746 185.898 166.356C185.898 165.966 185.582 165.649 185.191 165.649C184.801 165.649 184.484 165.966 184.484 166.356Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 184.739C349.932 185.129 350.248 185.446 350.639 185.446C351.029 185.446 351.346 185.129 351.346 184.739C351.346 184.348 351.029 184.032 350.639 184.032C350.248 184.032 349.932 184.348 349.932 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 184.739C331.548 185.129 331.865 185.446 332.255 185.446C332.645 185.446 332.962 185.129 332.962 184.739C332.962 184.348 332.645 184.032 332.255 184.032C331.865 184.032 331.548 184.348 331.548 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 184.739C313.165 185.129 313.482 185.446 313.872 185.446C314.262 185.446 314.579 185.129 314.579 184.739C314.579 184.348 314.262 184.032 313.872 184.032C313.482 184.032 313.165 184.348 313.165 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 184.739C294.782 185.129 295.099 185.446 295.489 185.446C295.88 185.446 296.196 185.129 296.196 184.739C296.196 184.348 295.88 184.032 295.489 184.032C295.099 184.032 294.782 184.348 294.782 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 184.739C276.399 185.129 276.716 185.446 277.106 185.446C277.497 185.446 277.813 185.129 277.813 184.739C277.813 184.348 277.497 184.032 277.106 184.032C276.716 184.032 276.399 184.348 276.399 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 184.739C258.017 185.129 258.333 185.446 258.724 185.446C259.114 185.446 259.431 185.129 259.431 184.739C259.431 184.348 259.114 184.032 258.724 184.032C258.333 184.032 258.017 184.348 258.017 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 184.739C239.634 185.129 239.951 185.446 240.341 185.446C240.731 185.446 241.048 185.129 241.048 184.739C241.048 184.348 240.731 184.032 240.341 184.032C239.951 184.032 239.634 184.348 239.634 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 184.739C221.251 185.129 221.568 185.446 221.958 185.446C222.348 185.446 222.665 185.129 222.665 184.739C222.665 184.348 222.348 184.032 221.958 184.032C221.568 184.032 221.251 184.348 221.251 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 184.739C202.868 185.129 203.185 185.446 203.575 185.446C203.965 185.446 204.282 185.129 204.282 184.739C204.282 184.348 203.965 184.032 203.575 184.032C203.185 184.032 202.868 184.348 202.868 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 184.739C184.484 185.129 184.801 185.446 185.191 185.446C185.582 185.446 185.898 185.129 185.898 184.739C185.898 184.348 185.582 184.032 185.191 184.032C184.801 184.032 184.484 184.348 184.484 184.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 203.121C349.932 203.512 350.248 203.829 350.639 203.829C351.029 203.829 351.346 203.512 351.346 203.121C351.346 202.731 351.029 202.414 350.639 202.414C350.248 202.414 349.932 202.731 349.932 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 203.121C331.548 203.512 331.865 203.829 332.255 203.829C332.645 203.829 332.962 203.512 332.962 203.121C332.962 202.731 332.645 202.414 332.255 202.414C331.865 202.414 331.548 202.731 331.548 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 203.121C313.165 203.512 313.482 203.829 313.872 203.829C314.262 203.829 314.579 203.512 314.579 203.121C314.579 202.731 314.262 202.414 313.872 202.414C313.482 202.414 313.165 202.731 313.165 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 203.121C294.782 203.512 295.099 203.829 295.489 203.829C295.88 203.829 296.196 203.512 296.196 203.121C296.196 202.731 295.88 202.414 295.489 202.414C295.099 202.414 294.782 202.731 294.782 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 203.121C276.399 203.512 276.716 203.829 277.106 203.829C277.497 203.829 277.813 203.512 277.813 203.121C277.813 202.731 277.497 202.414 277.106 202.414C276.716 202.414 276.399 202.731 276.399 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 203.121C258.017 203.512 258.333 203.829 258.724 203.829C259.114 203.829 259.431 203.512 259.431 203.121C259.431 202.731 259.114 202.414 258.724 202.414C258.333 202.414 258.017 202.731 258.017 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 203.121C239.634 203.512 239.951 203.829 240.341 203.829C240.731 203.829 241.048 203.512 241.048 203.121C241.048 202.731 240.731 202.414 240.341 202.414C239.951 202.414 239.634 202.731 239.634 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 203.121C221.251 203.512 221.568 203.829 221.958 203.829C222.348 203.829 222.665 203.512 222.665 203.121C222.665 202.731 222.348 202.414 221.958 202.414C221.568 202.414 221.251 202.731 221.251 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 203.121C202.868 203.512 203.185 203.829 203.575 203.829C203.965 203.829 204.282 203.512 204.282 203.121C204.282 202.731 203.965 202.414 203.575 202.414C203.185 202.414 202.868 202.731 202.868 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 203.121C184.484 203.512 184.801 203.829 185.191 203.829C185.582 203.829 185.898 203.512 185.898 203.121C185.898 202.731 185.582 202.414 185.191 202.414C184.801 202.414 184.484 202.731 184.484 203.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 221.505C349.932 221.895 350.248 222.212 350.639 222.212C351.029 222.212 351.346 221.895 351.346 221.505C351.346 221.114 351.029 220.798 350.639 220.798C350.248 220.798 349.932 221.114 349.932 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 221.505C331.548 221.895 331.865 222.212 332.255 222.212C332.645 222.212 332.962 221.895 332.962 221.505C332.962 221.114 332.645 220.798 332.255 220.798C331.865 220.798 331.548 221.114 331.548 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 221.505C313.165 221.895 313.482 222.212 313.872 222.212C314.262 222.212 314.579 221.895 314.579 221.505C314.579 221.114 314.262 220.798 313.872 220.798C313.482 220.798 313.165 221.114 313.165 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 221.505C294.782 221.895 295.099 222.212 295.489 222.212C295.88 222.212 296.196 221.895 296.196 221.505C296.196 221.114 295.88 220.798 295.489 220.798C295.099 220.798 294.782 221.114 294.782 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 221.505C276.399 221.895 276.716 222.212 277.106 222.212C277.497 222.212 277.813 221.895 277.813 221.505C277.813 221.114 277.497 220.798 277.106 220.798C276.716 220.798 276.399 221.114 276.399 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 221.505C258.017 221.895 258.333 222.212 258.724 222.212C259.114 222.212 259.431 221.895 259.431 221.505C259.431 221.114 259.114 220.798 258.724 220.798C258.333 220.798 258.017 221.114 258.017 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 221.505C239.634 221.895 239.951 222.212 240.341 222.212C240.731 222.212 241.048 221.895 241.048 221.505C241.048 221.114 240.731 220.798 240.341 220.798C239.951 220.798 239.634 221.114 239.634 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 221.505C221.251 221.895 221.568 222.212 221.958 222.212C222.348 222.212 222.665 221.895 222.665 221.505C222.665 221.114 222.348 220.798 221.958 220.798C221.568 220.798 221.251 221.114 221.251 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 221.505C202.868 221.895 203.185 222.212 203.575 222.212C203.965 222.212 204.282 221.895 204.282 221.505C204.282 221.114 203.965 220.798 203.575 220.798C203.185 220.798 202.868 221.114 202.868 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 221.505C184.484 221.895 184.801 222.212 185.191 222.212C185.582 222.212 185.898 221.895 185.898 221.505C185.898 221.114 185.582 220.798 185.191 220.798C184.801 220.798 184.484 221.114 184.484 221.505Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.932 239.888C349.932 240.278 350.248 240.595 350.639 240.595C351.029 240.595 351.346 240.278 351.346 239.888C351.346 239.497 351.029 239.181 350.639 239.181C350.248 239.181 349.932 239.497 349.932 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 239.888C331.548 240.278 331.865 240.595 332.255 240.595C332.645 240.595 332.962 240.278 332.962 239.888C332.962 239.497 332.645 239.181 332.255 239.181C331.865 239.181 331.548 239.497 331.548 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.165 239.888C313.165 240.278 313.482 240.595 313.872 240.595C314.262 240.595 314.579 240.278 314.579 239.888C314.579 239.497 314.262 239.181 313.872 239.181C313.482 239.181 313.165 239.497 313.165 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.782 239.888C294.782 240.278 295.099 240.595 295.489 240.595C295.88 240.595 296.196 240.278 296.196 239.888C296.196 239.497 295.88 239.181 295.489 239.181C295.099 239.181 294.782 239.497 294.782 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.399 239.888C276.399 240.278 276.716 240.595 277.106 240.595C277.497 240.595 277.813 240.278 277.813 239.888C277.813 239.497 277.497 239.181 277.106 239.181C276.716 239.181 276.399 239.497 276.399 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.017 239.888C258.017 240.278 258.333 240.595 258.724 240.595C259.114 240.595 259.431 240.278 259.431 239.888C259.431 239.497 259.114 239.181 258.724 239.181C258.333 239.181 258.017 239.497 258.017 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.634 239.888C239.634 240.278 239.951 240.595 240.341 240.595C240.731 240.595 241.048 240.278 241.048 239.888C241.048 239.497 240.731 239.181 240.341 239.181C239.951 239.181 239.634 239.497 239.634 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.251 239.888C221.251 240.278 221.568 240.595 221.958 240.595C222.348 240.595 222.665 240.278 222.665 239.888C222.665 239.497 222.348 239.181 221.958 239.181C221.568 239.181 221.251 239.497 221.251 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.868 239.888C202.868 240.278 203.185 240.595 203.575 240.595C203.965 240.595 204.282 240.278 204.282 239.888C204.282 239.497 203.965 239.181 203.575 239.181C203.185 239.181 202.868 239.497 202.868 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 239.888C184.484 240.278 184.801 240.595 185.191 240.595C185.582 240.595 185.898 240.278 185.898 239.888C185.898 239.497 185.582 239.181 185.191 239.181C184.801 239.181 184.484 239.497 184.484 239.888Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_36509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350.69,
    height: 240.392,
    fill: "white",
    transform: "translate(0.655273 0.202148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotBg);
export default __webpack_public_path__ + "static/media/dot-bg.adfaec1f47b617891e6812102cab6b08.svg";
export { ForwardRef as ReactComponent };